import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext, useEffect } from 'react';
import MetaDescription from 'ecosystem-marketplace-core/components/elements/MetaDescription';
import MetaRobots from 'ecosystem-marketplace-core/components/elements/MetaRobots';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import PrerenderStatusCode from 'ecosystem-marketplace-core/components/prerender/PrerenderStatusCode';
import { isFulfilled } from 'ecosystem-marketplace-core/utils/requestState';
import PageMetaOverridesContext from '../../../context/PageMetaOverridesContext';
import { useStorefrontDocumentTitle } from '../../../hooks/useStorefrontDocumentTitle';
import { useStorefrontMetaDescription } from '../../../hooks/useStorefrontMetaDescription';
import { PublicAppContext } from '../../../selectors/app';
import StorefrontCanonicalLinks from './StorefrontCanonicalLinks';
import StorefrontSocialSharing from './StorefrontSocialSharing';
const MIN_RESULTS = 4;

function StorefrontDocumentHead({
  description,
  pageCount,
  requestState,
  routeParams,
  searchTerm,
  title,
  total
}) {
  const {
    metaRobots: metaRobotsOverride,
    prerenderStatusCode: prerenderStatusCodeOverride
  } = useContext(PageMetaOverridesContext);
  const documentTitle = useStorefrontDocumentTitle({
    routeParams,
    title,
    total
  });
  const metaDescription = useStorefrontMetaDescription({
    description,
    routeParams
  });
  useEffect(() => {
    document.title = documentTitle;
  }, [documentTitle]);
  return /*#__PURE__*/_jsx(DocumentHead, {
    children: /*#__PURE__*/_jsx(PublicAppContext, {
      children: /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(MetaDescription, {
          content: metaDescription
        }), !metaRobotsOverride && (searchTerm || total < MIN_RESULTS) && /*#__PURE__*/_jsx(MetaRobots, {
          directive: ['nofollow', 'noindex']
        }), /*#__PURE__*/_jsx(StorefrontCanonicalLinks, {
          pageCount: pageCount,
          routeParams: routeParams
        }), /*#__PURE__*/_jsx(StorefrontSocialSharing, {
          description: metaDescription,
          title: documentTitle
        }), !prerenderStatusCodeOverride && !total && /*#__PURE__*/_jsx(PrerenderStatusCode, {
          statusCode: 404
        }), /*#__PURE__*/_jsx(PrerenderReady, {
          ready: isFulfilled(requestState)
        })]
      })
    })
  });
}

export default StorefrontDocumentHead;